export default __webpack_public_path__ + "static/media/dashboard_icon_red.2b650306.svg";